export default {"src":"/_next/static/media/Incognito.9be741eb.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};